import formatNumber from 'utils/format-number';

export const GainLoss = ({
  value,
  symbol,
  className,
  skeletonClass,
  arrow,
  loading,
  background = false,
  hidePrefix = false,
  hiddenString = false
}: {
  value?: string | number | undefined | null;
  percentage?: string | number | undefined | null;
  symbol?: string;
  className?: string;
  isPercentage?: boolean;
  skeletonClass?: string;
  arrow?: boolean;
  loading?: boolean;
  background?: boolean;
  hidePrefix?: boolean;
  hiddenString?: boolean;
}) => {
  if (loading || (!value && value !== 0)) {
    return <div className={`h-5 w-20 skeleton ${skeletonClass}`} />;
  }

  const valueWithoutWhitespace =
    typeof value === 'string' ? value.replace(' ', '') : value;

  const gainLoss = hiddenString ? 1 : Number(Number(valueWithoutWhitespace).toFixed(2));
  const gainLossDisplay = hiddenString ? valueWithoutWhitespace : formatNumber(Math.abs(gainLoss));

  let textColor = 'text-grey';
  let bgColor = 'bg-grey';
  let prefix = symbol || '';
  let extraArrow = '';

  if (gainLoss > 0 || hiddenString) {
    textColor = 'text-success';
    bgColor = 'bg-[rgb(35,221,178)]/[.20]';
    prefix = !symbol ? '↑ ' : symbol || '';
    extraArrow = '↑ ';
  }

  if (gainLoss < 0) {
    textColor = 'text-error';
    bgColor = 'bg-[rgb(255,109,105)]/[.20]';
    prefix = !symbol ? '↓ ' : symbol || '';
    extraArrow = '↓ ';
  }

  return (
    <div
      className={`flex items-center whitespace-nowrap py-0.5 px-1 rounded-md bg-opacity-20 ${textColor} ${background ? bgColor : ''} ${className}`}>
      {arrow && symbol && extraArrow}
      {!hidePrefix && prefix}
      {gainLossDisplay}
      {symbol ? '' : '%'}
    </div>
  );
};

export default GainLoss;
